import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

/** NumberStepper do DS (ORCA-1929): − valor + para números inteiros pequenos ("até 5x"). */
@Component({
    selector: 'oa-number-stepper',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <div class="oa-stepper" [class.oa-stepper--sm]="size === 'sm'" role="group" [attr.aria-label]="label">
            <button type="button" [attr.aria-label]="'Diminuir ' + label" [disabled]="disabled || value <= min" (click)="set(value - 1)">
                <mat-icon>remove</mat-icon>
            </button>
            <output aria-live="polite">{{ value }}{{ suffix }}</output>
            <button type="button" [attr.aria-label]="'Aumentar ' + label" [disabled]="disabled || value >= max" (click)="set(value + 1)">
                <mat-icon>add</mat-icon>
            </button>
        </div>
    `,
})
export class OaNumberStepperComponent {
    @Input() value = 1;
    @Input() min = 1;
    @Input() max = 12;
    @Input() suffix = '';
    @Input() label = 'Quantidade';
    @Input() disabled = false;
    /** 'sm': 36px de altura, para colunas estreitas */
    @Input() size: 'md' | 'sm' = 'md';
    @Output() valueChange = new EventEmitter<number>();

    set(next: number) {
        const value = Math.min(this.max, Math.max(this.min, next));
        if (value !== this.value) {
            this.value = value;
            this.valueChange.emit(value);
        }
    }
}
